import { createGlobalStyle, css } from 'styled-components';

export default createGlobalStyle`
  @import url('https://fonts.googleapis.com/css?family=Playfair+Display:400,700|Work+Sans:400,500,700&display=swap');
  /*! minireset.css v0.0.5 | MIT License | github.com/jgthms/minireset.css */html,body,p,ol,ul,li,dl,dt,dd,blockquote,figure,fieldset,legend,textarea,pre,iframe,hr,h1,h2,h3,h4,h5,h6{margin:0;padding:0}h1,h2,h3,h4,h5,h6{font-size:100%;font-weight:normal}ul{list-style:none}button,input,select,textarea{margin:0}html{box-sizing:border-box}*,*:before,*:after{box-sizing:inherit}img,video{height:auto;max-width:100%}iframe{border:0}table{border-collapse:collapse;border-spacing:0}td,th{padding:0;text-align:left}
  ${({ theme }) => css`
    html {
      font-family: 'Work Sans', sans-serif;
    }
    body {
      font-size: 14px;
      color: ${theme.color[theme.variant]};
      @media screen and (min-width: 768px) {
        font-size: 16px;
      }
    }
    button {
      background: none;
      border: 0;
      margin: 0;
      padding: 0;
      font-family: 'Work Sans', sans-serif;
      color: inherit;
    }
    a {
      color: ${theme.colors.chestnutRose};
      font-weight: normal;
      text-decoration: none;
    }
    h1,
    h2,
    h3,
    h4 {
      font-family: 'Playfair Display', serif;
    }
    h1 {
      color: ${theme.color.primary};
    }
    h2 {
      color: ${theme.colors.valhalla};
    }
    h4,
    h5,
    h6 {
      color: ${theme.color.secondary};
    }
    h5 {
      font-weight: bold;
    }
    h6 {
      text-transform: uppercase;
    }
    p {
      line-height: 1.625;
    }
    details {
      background: white;
      box-shadow: 0 0 24px 0 rgba(0, 0, 0, 0.04);
      border-radius: ${theme.borderRadius};
      color: ${theme.color.secondary};
      margin: 24px 0;
      padding: 24px;
      box-shadow: 0 0 24px 0 rgba(0, 0, 0, 0.04);
    }
    summary {
      text-transform: uppercase;
      color: ${theme.colors.chestnutRose};
      position: relative;
      cursor: pointer;
      outline: 0 !important;
      ::marker,
      ::-webkit-details-marker {
        display: none;
      }
      &:after {
        transition: 0.2s ease;
        content: '›';
        font-family: 'Courier New', Courier, monospace;
        transform: translateY(-50%) rotate(90deg);
        font-size: 24px;
        position: absolute;
        top: 50%;
        right: 8px;
        color: ${theme.color.secondary};
      }
    }
    summary::marker {
      display: none;
    }
    summary::-webkit-details-marker {
      display: none;
    }
    &[open] summary {
      margin-bottom: 16px;
      &:after {
        transform: translateY(-50%) rotate(270deg);
      }
    }
    table {
      /* Remove spacing between table cells (from Normalize.css) */
      border-collapse: collapse;
      border-spacing: 0;
      empty-cells: show;
      border: 1px solid #cbcbcb;
    }

    table caption {
      color: #000;
      font: italic 85%/1 arial, sans-serif;
      padding: 1em 0;
      text-align: center;
    }

    table td,
    table th {
      border-left: 1px solid #cbcbcb; /*  inner column border */
      border-width: 0 0 0 1px;
      font-size: inherit;
      margin: 0;
      overflow: visible; /*to make ths where the title is really long work*/
      padding: 0.5em 1em; /* cell padding */
    }

    table thead {
      background-color: #e0e0e0;
      color: #000;
      text-align: left;
      vertical-align: bottom;
    }

    table td {
      border-bottom: 1px solid #cbcbcb;
      background-color: transparent;
    }
    table tbody > tr:last-child > td {
      border-bottom-width: 0;
    }
  `}
`;
